import { useHistory } from "react-router-dom";

export function KioskBackButton() {
  const history = useHistory();

  return (
    <button
      className="absolute right-4 top-6 text-4xl text-empty sm:top-3 sm:text-2xl"
      onClick={() => history.goBack()}
      type="button"
    >
      <i className="far fa-xmark" />
    </button>
  );
}
